import type { ReactNode } from 'react';

export type Fact = { key: string; label: string; value: ReactNode; testId?: string };

/** Signature 3: key and value in two columns, parted by hairlines. */
export function Facts({ facts, top = true }: { facts: Array<Fact | null | false>; top?: boolean }) {
  return (
    <dl className={top ? 'facts facts-top' : 'facts'}>
      {facts
        .filter((f): f is Fact => Boolean(f))
        .map((f) => (
          <div key={f.key} className="fact">
            <dt>{f.label}</dt>
            <dd data-testid={f.testId}>{f.value}</dd>
          </div>
        ))}
    </dl>
  );
}
